import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'

interface ILanguage {
  id: number
  name: string
}

function LanguageAutocomplete({ value, handleInputChange, type }: any) {
  const { t } = useTranslation(['global'])

  const { languages } = useSelector((state: IRootState) => state.language)
  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const handleAutoCompleteChange = (language: ILanguage | null) => {
    handleInputChange('language', language)
  }

  return (
    <Autocomplete
      id="autocomplete-language"
      ChipProps={{ color: 'secondary' }}
      value={value}
      onChange={(_, value) => handleAutoCompleteChange(value)}
      options={languages}
      getOptionLabel={(language: ILanguage) => (language.id !== undefined ? language.name : '')}
      renderInput={params => (
        <TextField
          {...params}
          required
          label={t('language')}
          variant="filled"
          InputLabelProps={{ shrink: true }}
          error={errorForm.language}
          helperText={msgForm.language}
        />
      )}
    />
  )
}

export default LanguageAutocomplete
